export default {
    cn: {
        cpaIBResult: {
            indexText: 'CPA佣金结果',
            text: 'CPA月结佣金计算结果',
            datailText: 'CPA月结佣金计算结果明细',
            goback: '返回',
            start_time: "开始时间：",
            end_time: "结束时间：",
            selectTimeText: '选择日期',
            clauses_text: "显示条目数",
            amount: "总数",
            present: "当前",
            downloadExcelForms: "下载 Excel",
            nodata: "没有查询到数据",
            search: '搜索',
            commissionType: '佣金类别：',
            proxyAccount: '代理账号：',
            type: 'CPA佣金',
            status: '状态：',
            confirm: '佣金确定',
            reject: '佣金拒绝',
            rejectMessage: '请输入拒绝原因',
            commit: '您真的要确定/拒绝吗?',
            total: { TOTAL: "合计", part: "part", index: 1 },
            statusList: { "0": "未确定", "1": "全部确定", "2": "部分确定" },
            CPAStatusList: { "-1": "所有", "2": "未确定", "3": "已确定", "4": "已拒绝" },
            cpaIndexTh: [{
                key: 'REPORT_ID',
                name: '编号'
            }, {
                key: 'CPACommissionResult',
                name: 'CPA佣金计算结果',
                unneed: false
            }, {
                key: 'DATE_FROM',
                name: '开始时间'
            }, {
                key: 'DATE_TO',
                name: '结束时间'
            }, {
                key: 'LAST_UPDATE',
                name: '完成时间',
                changeTime: true
            }, {
                key: 'status',
                name: '状态'
            }],
            computeTh: [{
                key: 'IB_ID',
                name: '代理账号'
            }, {
                key: 'IB_NAME',
                name: '代理姓名'
            }, {
                key: 'CPA_COMMISSION',
                name: '金额'
            }, {
                key: 'NO_OF_CLIENT',
                name: '即月达标客户数量'
            }, {
                key: 'TOTAL_NO_OF_CLIENT',
                name: '总共达标客户数量'
            }, {
                key: 'status',
                name: '状态'
            }, {
                key: 'REJECT_REASON',
                name: '拒绝原因'
            }, {
                key: 'DEPOSIT_ORDER_ID',
                name: '佣金单号'
            }, {
                key: 'DEPOSIT_COMMENT',
                name: '佣金注解'
            }, {
                key: 'UPDATE_BY',
                name: '最后更新'
            }, {
                key: 'LAST_UPDATE',
                name: '更新时间',
                changeTime: true
            }],
            detailTh: [{
                key: 'ib_id',
                name: '代理账号'
            }, {
                key: 'CLIENT_ID',
                name: '达标客户账号'
            }, {
                key: 'CLIENT_NAME',
                name: '达标客户姓名'
            }, {
                key: 'CLIENT_DOC_NO',
                name: '证件号码'
            }, {
                key: 'LOT',
                name: '手数'
            }, {
                key: 'CPA_COMMISSION',
                name: '金额'
            }]
        }
    },
    hk: {
        cpaIBResult: {
            indexText: 'CPA佣金結果',
            text: 'CPA月結佣金計算結果',
            datailText: 'CPA月結佣金計算結果明細',
            goback: '返回',
            start_time: "開始時間：",
            end_time: "結束時間：",
            selectTimeText: '選擇日期',
            clauses_text: "顯示條目數",
            amount: "總數",
            present: "當前",
            downloadExcelForms: "下載 Excel",
            search: "搜索",
            nodata: "沒有查詢到數據",
            commissionType: '佣金類別：',
            proxyAccount: '代理賬號：',
            type: 'CPA佣金',
            status: '狀態：',
            confirm: '佣金確定',
            reject: '佣金拒絕',
            rejectMessage: '請輸入拒絕原因',
            commit: '您真的要確定/拒絕嗎?',
            total: { TOTAL: "合計", part: "part", index: 1 },
            statusList: { "0": "未確定", "1": "全部確定", "2": "部分確定" },
            CPAStatusList: { "-1": "所有", "2": "未確定", "3": "已確定", "4": "已拒絕" },
            cpaIndexTh: [{
                key: 'REPORT_ID',
                name: '編號'
            }, {
                key: 'CPACommissionResult',
                name: 'CPA佣金計算結果',
                unneed: false
            }, {
                key: 'DATE_FROM',
                name: '開始時間'
            }, {
                key: 'DATE_TO',
                name: '結束時間'
            }, {
                key: 'LAST_UPDATE',
                name: '完成時間',
                changeTime: true
            }, {
                key: 'status',
                name: '狀態'
            }],
            computeTh: [{
                key: 'IB_ID',
                name: '代理賬號'
            }, {
                key: 'IB_NAME',
                name: '代理姓名'
            }, {
                key: 'CPA_COMMISSION',
                name: '金額'
            }, {
                key: 'NO_OF_CLIENT',
                name: '即月達標客戶數量'
            }, {
                key: 'TOTAL_NO_OF_CLIENT',
                name: '總共達標客戶數量'
            }, {
                key: 'status',
                name: '狀態'
            }, {
                key: 'REJECT_REASON',
                name: '拒絕原因'
            }, {
                key: 'DEPOSIT_ORDER_ID',
                name: '佣金單號'
            }, {
                key: 'DEPOSIT_COMMENT',
                name: '佣金注解'
            }, {
                key: 'UPDATE_BY',
                name: '最後更新'
            }, {
                key: 'LAST_UPDATE',
                name: '更新時間',
                changeTime: true
            }],
            detailTh: [{
                key: 'ib_id',
                name: '代理賬號'
            }, {
                key: 'CLIENT_ID',
                name: '達標客戶賬號'
            }, {
                key: 'CLIENT_NAME',
                name: '達標客戶姓名'
            }, {
                key: 'CLIENT_DOC_NO',
                name: '證件號碼'
            }, {
                key: 'LOT',
                name: '手數'
            }, {
                key: 'CPA_COMMISSION',
                name: '金額'
            }]
        }
    },
    en: {
        cpaIBResult: {
            indexText: 'CPA Commisson Result',
            text: 'CPA Monthly commission Result',
            datailText: 'CPA Monthly Commission Result Detail',
            goback: 'Go Back',
            start_time: "Start Time：",
            end_time: "End Time：",
            selectTimeText: 'Select Date',
            search: 'Search',
            clauses_text: "Display",
            amount: " Total Count",
            present: "Current",
            downloadExcelForms: "Download Excel",
            nodata: "No data found",
            search: 'Search',
            commissionType: 'Type：',
            proxyAccount: 'Account：',
            type: 'CPA Commission',
            status: 'Status：',
            confirm: 'Confirm',
            reject: 'Reject',
            rejectMessage: 'Please enter a reject reason',
            commit: 'Do you really want to confirm/reject?',
            total: { TOTAL: "Total", part: "part", index: 1 },
            statusList: { "0": "Unconfirmed", "1": "All Confirmed", "2": "Partially Confirmed" },
            CPAStatusList: { "-1": "All", "2": "Unconfirmed", "3": "Confirmed", "4": "Rejected" },
            cpaIndexTh: [{
                key: 'REPORT_ID',
                name: 'Record ID'
            }, {
                key: 'CPACommissionResult',
                name: 'CPA Commission Result',
                unneed: false
            }, {
                key: 'DATE_FROM',
                name: 'Start Time'
            }, {
                key: 'DATE_TO',
                name: 'End Time'
            }, {
                key: 'LAST_UPDATE',
                name: 'Completion Time',
                changeTime: true
            }, {
                key: 'status',
                name: 'Status'
            }],
            computeTh: [{
                key: 'IB_ID',
                name: 'IB Account'
            }, {
                key: 'IB_NAME',
                name: 'IB name'
            }, {
                key: 'CPA_COMMISSION',
                name: 'Amount'
            }, {
                key: 'NO_OF_CLIENT',
                name: 'Current Month Count'
            }, {
                key: 'TOTAL_NO_OF_CLIENT',
                name: 'Total Count'
            }, {
                key: 'status',
                name: 'Status'
            }, {
                key: 'REJECT_REASON',
                name: 'Reject Reason'
            }, {
                key: 'DEPOSIT_ORDER_ID',
                name: 'Order ID'
            }, {
                key: 'DEPOSIT_COMMENT',
                name: 'Comment'
            }, {
                key: 'UPDATE_BY',
                name: 'Update By'
            }, {
                key: 'LAST_UPDATE',
                name: 'Last Update',
                changeTime: true
            }],
            detailTh: [{
                key: 'ib_id',
                name: 'IB account'
            }, {
                key: 'CLIENT_ID',
                name: 'Client ID'
            }, {
                key: 'CLIENT_NAME',
                name: 'Client Name'
            }, {
                key: 'CLIENT_DOC_NO',
                name: 'Client Doc Number'
            }, {
                key: 'LOT',
                name: 'LOTS'
            }, {
                key: 'CPA_COMMISSION',
                name: 'Amount'
            }]
        }
    }
}


// WEBPACK FOOTER //
// ./src/MultiLanguage/CommissionSetting/IB/cpaIBResult.js